<template>
  <ExternalEntityViewData
    :back_button="!isApplicationUser"
    :entity_label="true"
    :add_filter="!isApplicationUser"
    :settings="!isApplicationUser"
    :filter_list="!isApplicationUser"
    :entity_id="entity_id"
    :sort_order="sort_order"
    :sort_column="sort_column"
    :currentPage="currentPage"
    :limit="limit"
    :currentFilter="currentFilter"
    :relationalEntityId="relationalEntityId"
    :relationalEntityData="relationalEntityData"
    @sort-column-order-apply="applySort"
    @page-apply="applyPage"
    @update-filter="updateFilterParams"
  ></ExternalEntityViewData>
</template>
<script>
import { mapGetters } from "vuex";
import { postAPICall } from "../../helpers/httpHelper";
export default {
  data() {
    return {
      relationalEntityId: "",
      relationalEntityData: {},
      currentPage: 1,
      limit:20
    };
  },
  async mounted() {
    await this.getApplcationUserInfo();
  },
  components: {
    ExternalEntityViewData: () => import("./externalEntityViewData.vue"),
  },
  computed: {
    ...mapGetters("auth", ["getActiveContactType"]),
    isApplicationUser() {
      return this.$route.name === "application-user-external-entity";
    },
    sort_order() {
      return this.$route.query.sort_order
        ? this.$route.query.sort_order
        : "ascending";
    },
    sort_column() {
      return this.$route.query.sort_column ? this.$route.query.sort_column : "";
    },
    currentFilter() {
      return this.$route.query.filter ? this.$route.query.filter : "";
    },
    entity_id() {
      return this.$route.params.entity_id;
    },
  },
  methods: {
    applySort(column, order) {
      this.$router.push({
        query: {
          ...this.$route.query,
          sort_column: column.columnKey,
          sort_order: order,
        },
      });
    },
    applyPage(value) {
      this.currentPage = value;
    },
    updateFilterParams(value) {
      this.$router.push({
        query: {
          ...this.$route.query,
          filter: value,
        },
      });
    },
    async getApplcationUserInfo() {
      try {
        if (this.isApplicationUser) {
          this.relationalEntityId = this.getActiveContactType.contact_type._id;
          let response = await postAPICall(
            "GET",
            `/entity-data/${this.getActiveContactType.account_data_id}`
          );
          this.relationalEntityData = response.data.templates_fields_data;
        }
      } catch (err) {
        console.log("Err", err);
      }
    },
  },
};
</script>
